<div class="bmc-timezone">
  <bzg-loading class="bmc-timezone__loading" [size]="'l'" *ngIf="showLoading"><strong class="bz-font-size--body-small">{{'TIMEZONE.LOADING' | translate}}</strong>
  </bzg-loading>

  <div class="bmc-timezone-main" *ngIf="!showLoading">
    <div class="bmc-timezone-main__header bz-space--stack-l">
      <bzg-icon [nameIcon]="'warning'" [size]="20" class="bz-space--inline-s bz-icon-color--warning"></bzg-icon>
      <h5>{{'TIMEZONE.HEADING' | translate}}</h5>
    </div>

    <div class="bmc-timezone-main__content">
      <bzg-select class="bmc-timezone-main__content-select" placeholder="{{'TIMEZONE.PLACEHOLDER' | translate}}" [(value)]="currentTimeZone.Id">
        <bzg-option *ngFor="let itemTimezone of listTimezone" [value]="itemTimezone.Id">{{itemTimezone.DisplayName}}</bzg-option>
      </bzg-select>

      <bzg-button-primary  class="bmc-timezone-main__content-button" (click)="onSave()">
        {{'GLOBAL.SAVE' | translate}}
      </bzg-button-primary>
    </div>
  </div>
</div>




